import classNames from 'classnames';
import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import { validateString } from 'utils/validate-string';

import styles from './card.module.scss';

interface Props {
  readonly className?: string | undefined;
  readonly children?: ReactNode | undefined;
}

const rootClass = validateString(styles.root);

export default function Card({ className, children }: Props): ReactElement {
  return <div className={classNames(rootClass, className)}>{children}</div>;
}
